<template>
  <el-aside
    width="auto"
    class="sidebar"
  >
    <el-row
      type="flex"
      justify="space-between"
      align="center"
      class="sidebar-header"
    >
      <el-col
        v-if="!sidebarIsCollapsed"
        :span="16"
      >
        <div class="image-container">
          <el-image
            :src="require('@/assets/images/logo.png')"
            fit="cover"
            class="sidebar-header__logo"
            width="100%"
            height="100%"
          />
        </div>
      </el-col>
      <el-col :span="7">
        <el-tag
          class="sidebar-header__env"
          type="info"
          v-if="deployment && deployment !== '' && deployment !== 'production'"
          >{{ deployment }}</el-tag
        >
      </el-col>
      <!-- <el-col
        class="sidebar-header__collapse-container"
        :span="sidebarIsCollapsed?24:4"
      >
        <i
          :class="`sidebar-header__collapse-button ${sidebarIsCollapsedIcon}`"
          @click="collapseSidebar"
        />
      </el-col> -->
    </el-row>
    <div
      :class="[
        'menu__container',
        sidebarIsCollapsed ? 'menu__container--collapsed' : '',
      ]"
    >
      <SidebarMenu
        :menu-items="menuItems"
        :sidebar-is-collapsed="sidebarIsCollapsed"
        class="sidebar-menu"
      />
      <div class="sidebar-tools">
        <el-button
          type="secondary"
          class="logout-button"
          @click="logoutUser"
        >
          <span class="logout-button__text">{{
            loggedUser && loggedUser.username
          }}</span>
          <i class="logout-button__icon fas fa-sign-out"></i>
        </el-button>
      </div>
      <span class="version-text">Version {{ version }}</span>
    </div>
  </el-aside>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import SidebarMenu from './SidebarMenu.vue';

  export default {
    name: 'MainSidebar',
    components: {
      SidebarMenu,
    },
    props: {
      menuItems: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        sidebarIsCollapsed: false,
        sidebarIsCollapsedIcon: 'fas fa-arrow-from-right',
      };
    },
    computed: {
      ...mapGetters(['loggedUser', 'version', 'deployment']),
    },
    methods: {
      ...mapActions(['setLoggedUser']),
      collapseSidebar() {
        this.sidebarIsCollapsed = !this.sidebarIsCollapsed;
        if (this.sidebarIsCollapsed) {
          this.sidebarIsCollapsedIcon = 'fas fa-arrow-from-left';
        } else {
          this.sidebarIsCollapsedIcon = 'fas fa-arrow-from-right';
        }
      },
      logoutUser() {
        this.setLoggedUser(null);
      },
    },
  };
</script>

<style lang="scss">
  .version-text {
    margin: 0.25rem 1.25rem 1.25rem 1.25rem;
    color: #ffffff;
    font-size: 0.87rem;
  }
  .sidebar-header {
    display: flex;
    align-items: center;
    height: $header-height;
    border-right: none;
    border-bottom: none;

    > .el-col {
      display: flex;
      align-items: center;
    }

    &__logo {
      box-sizing: border-box;
      width: auto;
      max-width: 100%;
      padding: 15px 9px 15px 20px;
    }

    &__env.el-tag {
      border-radius: 50px;
      background-color: $--border-color-base;
      border-color: $--border-color-base;
    }

    &__collapse-container {
      text-align: center;
      padding-top: 28px;
    }

    &__collapse-button {
      cursor: pointer;
      color: $--color-white;
    }
  }
  .collapse-sidebar {
    cursor: pointer;
  }
  .sidebar {
    min-height: 100vh;
    border-right: 3px solid $--color-black-lighter;
  }
  .menu {
    &__container {
      height: calc(100% - #{$header-height});
      overflow: hidden;
      background-color: $--menu-background-color;
      border-right: none;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .menubar {
    &__sync {
      .menu-item {
        border-top: 1px solid #62798d;
        border-bottom: 0;
        height: 56px;
        font-size: 12px;
        line-height: 1.4;
        text-align: right;
        display: flex;
        justify-content: space-around;
        align-items: center;

        &.is-active {
          .menu-item__icon {
            animation: fa-spin 2s infinite linear;
          }
        }
      }
    }
  }

  .sidebar-tools {
    margin: 0.5rem 1.25rem 0.25rem 1.25rem;
  }

  .logout-button {
    padding: 0;
    border: none;

    &:hover,
    &:focus {
      background-color: $--color-black-lighter;
      color: $--color-white;
    }

    &__text {
      display: inline-block;
      font-size: 0.87rem;
      padding: 0.62rem 1.25rem 0.62rem 1.25rem;
    }
    &__icon {
      display: inline-block;
      font-size: 0.87rem;
      padding: 0.62rem;
      background-color: $--color-warning;
      border-radius: 0 4px 4px 0;
      line-height: 1.1;
    }
  }

  .menu__container {
    .sidebar-menu {
      height: calc(100vh - 190px);
      overflow-y: auto;
    }
  }

  .image-container {
    width: 200px;

    img {
      width: 100%;
      background-color: hsl(224 11% 90% / 1);
      height: 100%;
      clip-path: inset(25% 0% 25% 0% round 4px);
    }
  }
</style>
